import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import PremiumDMCCard from "../components/PremiumDMCCard";
import { api } from "../lib/api";
import { Globe2 } from "lucide-react";

export default function PremiumDMCsPage() {
  const [dmcs, setDmcs] = useState([]);
  const [premiumOnly, setPremiumOnly] = useState(false);

  useEffect(() => {
    api.get(`/dmcs${premiumOnly ? "?premium_only=true" : ""}`).then((r) => setDmcs(r.data || []));
  }, [premiumOnly]);

  return (
    <div className="App" data-testid="premium-dmcs-page">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 py-12">
        <p className="overline">Network · Verified DMCs</p>
        <h1 className="font-display text-4xl md:text-6xl font-black tracking-tighter text-white mt-3 uppercase">
          The <span className="text-brand">global</span> partner roster.
        </h1>
        <p className="text-[#a3a3a3] mt-4 max-w-2xl">
          From the Maldives to Kenya, these DMCs power TrawellDMC's matchmaking engine. Premium-tier
          partners receive priority placement and AI-boosted scoring.
        </p>

        <div className="inline-flex bg-[#0a0a0a] border border-[#262626] rounded-md mt-8 p-1">
          {[
            { v: false, label: "All DMCs" },
            { v: true, label: "Premium only" },
          ].map((t) => (
            <button
              key={String(t.v)}
              onClick={() => setPremiumOnly(t.v)}
              className={`px-4 py-2 rounded-sm text-sm transition-colors ${
                premiumOnly === t.v ? "bg-brand text-white font-bold" : "text-[#a3a3a3] hover:text-white"
              }`}
              data-testid={`filter-${t.v ? "premium" : "all"}`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10" data-testid="dmcs-grid">
          {dmcs.map((d, i) => (
            <PremiumDMCCard key={d.user_id} dmc={d} idx={i} />
          ))}
        </div>
        {dmcs.length === 0 && (
          <div className="border border-[#262626] rounded-xl p-12 text-center text-[#737373] mt-10" data-testid="dmcs-empty">
            <Globe2 className="w-8 h-8 mx-auto" />
            <p className="mt-3">No DMCs yet — try seeding demo data via /api/seed.</p>
          </div>
        )}
      </div>
    </div>
  );
}
